module.exports = __webpack_public_path__ + "img/whats-new_jp.1eff960.jpg";